import React from "react";
import { Col, Row } from "react-bootstrap";
import QuoteFor from "./QuoteFor";
import { Button, CircularProgress } from "@material-ui/core";
import NoQuoteAvailable from "../../../../Quoters/Common/SubComponents/NoQuoteAvailable";
import QuoteCard from "./QuoteCard";

export default function QuoteResult(props) {

    const { formState, fullFormState, quoteResults, isPiAgeIsMetWithAgeLimit, loading, isSurvivorshipPolicyType, onMultiFieldChange, onNext } = props;

    const quotes = (quoteResults && quoteResults.quotes) || null;
    const isQuoteAvailable = quotes && quotes.length > 0;
    const successfulQuote = quotes && quotes.filter(index => index.success === true);
    const jointPolicyQuotes = quotes && quotes.filter(index => index.success === true && index.isJointPolicy === true);
    const individualQuotes = quotes && quotes.filter(index => index.success === true && index.isJointPolicy === false);
    const isSuccessQuoteAvailable = isQuoteAvailable && (successfulQuote.length > 0);
    const isIllustrationDisable = fullFormState.pages.retrieveAccount.clientType === 'Prospect' || (isSurvivorshipPolicyType ? (!isSuccessQuoteAvailable || !isPiAgeIsMetWithAgeLimit) : !isQuoteAvailable) || loading

    const getQuotes = (isJointPolicy = false) => {
        if (isQuoteAvailable) {
            return quotes.map((index, i) => {
                if ((index.isJointPolicy === isJointPolicy) && index.success) {
                    return (
                        <QuoteCard
                            logoUrl={index.logoUrl}
                            productName={index.product}
                            monthlyRate={index.initialTotalLTCBenefit}
                            rating={index.rating}
                            index={i}
                            monthlyBenefit={index.initialMonthlyLTCBenefit}
                            deathBenefit={index.initialDeathBenefit}
                            minDeathBenefit={index.guaranteedMinDeathBenefit}
                            totalBenefit={index.endOfYearCoverage}
                            quoteResults={index}
                            isSurvivorshipPolicyType={isSurvivorshipPolicyType}
                            isJointPolicy={index.isJointPolicy}
                            insuredBasicInfo={props.fullFormState.pages.insuredBasicInfo}
                            clientCoverage={props.fullFormState.pages.clientCoverage}
                        />
                    )
                }
            })
        } else {
            return <NoQuoteAvailable />
        }
    }

    const onButtonClick = (isRequestIllustration) => {
        let newForm = { ...fullFormState }
        if (isRequestIllustration) {
            if (fullFormState.pages.retrieveAccount.clientType === 'Prospect') {
                return;
            }
            newForm.pages.quoter.isCompareSelected = false;
        }
        else
            newForm.pages.quoter.isCompareSelected = true;
        onMultiFieldChange(newForm);
        onNext();
    }

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="quote-result-section w-100 mb-3">
                        <QuoteFor coverageAmount={formState.coverageAmount} separator />
                    </div>
                </Col>
            </Row>
            <Row className='quoter w-100 px-0 mb-2 align-items-center'>
                <Col sm={isSurvivorshipPolicyType ? 4 : 3} className='px-0'>
                    {!isSurvivorshipPolicyType &&
                        <Button variant="outlined" className='detailed-view-btn float-left ml-3 mt-2' fullWidth color="primary" disabled={!isQuoteAvailable || loading} onClick={() => onButtonClick(false)}>
                            DETAILED VIEW
                        </Button>
                    }
                </Col>
                <Col sm={4}>
                    {!loading && isSurvivorshipPolicyType && isSuccessQuoteAvailable && (jointPolicyQuotes && jointPolicyQuotes.length > 0) &&
                        <h2 className="d-flex justify-content-center policy-title mt-3">Joint Policies</h2>
                    }
                </Col>
                <Col sm={isSurvivorshipPolicyType ? 4 : 5} className='px-0'>
                    <Button variant="contained" className='float-right mt-2 mr-n3' color="primary" disabled={isIllustrationDisable} onClick={() => onButtonClick(true)} >
                        REQUEST ILLUSTRATION
                    </Button>
                </Col>
            </Row>

            {
                loading ?
                    <div className="no-quote-container">
                        <CircularProgress />
                    </div> :
                    isSurvivorshipPolicyType ?
                        (isSuccessQuoteAvailable ? (<div>
                            {getQuotes(true)}
                            {(individualQuotes && individualQuotes.length > 0) && <h2 className="d-flex justify-content-center policy-title">Individual Policies</h2>}
                            {getQuotes(false)}
                        </div>) : <NoQuoteAvailable />)
                        : getQuotes()
            }
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/SubComponents/QuoteResult.js